export const MAX_SCREEN_WIDTH = 1440;
export type HeroType = 'carousel' | 'circle' | 'default';